// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProgramsDiff__wrapper___x0XM4","title":"ProgramsDiff__title___1x81i"};